import {
  LOAD_FORM3,
  LOAD_FORM3_SUCCESS,
  SET_FORM3_SECTION,
  SAVE_FORM3,
  CHANGE_STATUS3,
  CHANGE_STATUS3_SUCCESS,
  VALIDATION_ERROR,
  REQUEST_FORM3_SECTION,
  ADD_NOTE3,
  UPLOADv3,
  FORM_CLOSE3,
  UNLOAD_FORM3,
  REQUEST_CHANGE_STATUS3,
  SET_VALIDATION_MESSAGE3,
  CONFIRM_VALIDATION_MESSAGE3,
  STOP3,
  INC_FORM3_SECTION,
  LOAD_FORM3_FAIL,
  RESET_ZEROID,
} from "../constants";

export const loadForm3 = ({ formId, formDataId, activeSectionIndex }) => {
  return {
    type: LOAD_FORM3,
    formId,
    formDataId,
    activeSectionIndex,
  };
};

export const loadForm3Success = ({
  nodes,
  rootId,
  formData,
  formProcess,
  connections,
  validations,
  state,
  attachments,
}) => {
  return {
    type: LOAD_FORM3_SUCCESS,
    nodes,
    rootId,
    formData,
    connections,
    formProcess,
    validations,
    state,
    attachments,
  };
};

export const loadForm3Fail = ({ err }) => {
  return {
    type: LOAD_FORM3_FAIL,
    err,
  };
};

export const requestForm3Section = ({
  index,
  direction = 1,
  ignoreValidationErrors,
  force,
  effects,
}) => {
  return {
    type: REQUEST_FORM3_SECTION,
    index,
    direction,
    ignoreValidationErrors,
    force,
    effects,
  };
};

export const requestChangeStatus3 = ({
  formId,
  formDataId,
  parentFormDataId,
  currentStateId,
  connectionId,
  to,
  force,
}) => {
  return {
    type: REQUEST_CHANGE_STATUS3,
    formDataId,
    formId,
    currentStateId,
    connectionId,
    parentFormDataId,
    to,
    force,
  };
};

export const setForm3Section = ({ index }) => {
  return {
    type: SET_FORM3_SECTION,
    index,
  };
};

export const incForm3Section = () => {
  return {
    type: INC_FORM3_SECTION,
  };
};

export const saveForm3 = ({ id, key, value, data, context }) => {
  return {
    type: SAVE_FORM3,
    id,
    key,
    value,
    data,
    context,
  };
};

export const changeStatus3 = ({
  formId,
  formDataId,
  currentStateId,
  connectionId,
  to,
  force,
}) => {
  return {
    type: CHANGE_STATUS3,
    formDataId,
    formId,
    currentStateId,
    connectionId,
    to,
    force,
  };
};

//eslint-disable-next-line
export const changeStatus3Success = () => {
  return {
    type: CHANGE_STATUS3_SUCCESS,
  };
};

export const setValidationError = ({ key, results }) => {
  return {
    type: VALIDATION_ERROR,
    results,
    key,
  };
};

export const addNote3 = ({
  note,
  formDataId,
  noteId,
  noSaga,
  noteType,
  origin,
}) => {
  return {
    type: ADD_NOTE3,
    note,
    formDataId,
    noteId,
    noSaga,
    noteType,
    origin,
  };
};

/**
 * @desc Upload file to collection
 *
 */
export const uploadv3 = ({
  name,
  data,
  mimeType,
  _id,
  page,
  assetId,
  size,
  formDataId,
  componentId,
  uploadName,
}) => {
  return {
    type: UPLOADv3,
    name,
    data,
    mimeType,
    page,
    _id,
    assetId,
    size,
    formDataId,
    uploadName,
    componentId,
  };
};

//eslint-disable-next-line
export const closeForm3 = () => {
  return {
    type: FORM_CLOSE3,
  };
};

//eslint-disable-next-line
export const unloadForm3 = ({ formDataId }) => {
  console.log("UNLOAD_FORM3 - ACTION", formDataId);
  return {
    type: UNLOAD_FORM3,
    formDataId,
  };
};

export const setValidationMessage = (payload) => {
  return {
    type: SET_VALIDATION_MESSAGE3,
    payload,
  };
};

export const confirmValidationMessage = () => {
  return {
    type: CONFIRM_VALIDATION_MESSAGE3,
  };
};

export const setFormStop3 = ({ stop }) => {
  return {
    type: STOP3,
    stop,
  };
};

export const resetZeroId = ({ ids }) => {
  return {
    type: RESET_ZEROID,
    ids,
  };
};
